// extracted by mini-css-extract-plugin
export var billingAddress = "_y6-g";
export var contactInfo = "_y6-d";
export var customerInfoContainer = "_y6-c";
export var customerInfoContainerMobile = "_y6-h";
export var customerInfoRow = "_y6-a";
export var customerInfoSection = "_y6-b";
export var fullWidthDividerMobile = "_y6-i";
export var imageContainer = "_y6-1";
export var paymentMethod = "_y6-e";
export var priceText = "_y6-6";
export var priceTextMobile = "_y6-7";
export var product = "_y6-0";
export var productImage = "_y6-2";
export var productInfo = "_y6-4";
export var productMobile = "_y6-9";
export var productTitle = "_y6-8";
export var quantityBadge = "_y6-3";
export var quantityText = "_y6-5";
export var shippingAddress = "_y6-f";